// TopBanner.js
import {
  defineComponent,
  ref,
  computed,
  onMounted,
  onUnmounted,
} from "/Scripts/vue.esm-browser.js";
const html = String.raw;

export default defineComponent({
  name: "TopBanner",
  props: {
    images: {
      type: Array,
    },
    videos: {
      type: Array,
    },
    shopName: {
      type: String,
    },
    shopEnName: {
      type: String,
    },
  },
  emits: [],
  setup(props, { emit }) {
    const screenWidth = ref(window.innerWidth);

    // 響應式計算是否應該顯示banner（基於CSS媒體查詢的條件）
    const shouldShowBanner = computed(() => {
      return screenWidth.value > 576;
    });
    const shouldShowMobileBanner = computed(() => {
      return !shouldShowBanner.value;
    });

    // 計算要顯示的單一媒體資源（以圖片優先）
    const primaryMedia = computed(() => {
      if (!props.videos || props.videos.length === 0) {
        return null;
      }

      // 先篩選出圖片檔案
      const imageFiles = props.videos.filter(
        (item) => item.indexOf(".mp4") === -1
      );

      // 如果有圖片，優先顯示第一張圖片
      if (imageFiles.length > 0) {
        return {
          type: "image",
          src: imageFiles[0],
        };
      }

      // 如果沒有圖片，顯示第一個影片
      const videoFiles = props.videos.filter(
        (item) => item.indexOf(".mp4") > -1
      );

      if (videoFiles.length > 0) {
        return {
          type: "video",
          src: videoFiles[0],
        };
      }

      return null;
    });
    const primaryMobileImage = computed(() => {
      if (!props.images || props.images.length === 0) {
        return null;
      }

      return props.images[0];
    });

    // 監聽視窗大小變化
    const handleResize = () => {
      screenWidth.value = window.innerWidth;
    };

    onMounted(() => {
      window.addEventListener("resize", handleResize);
    });

    onUnmounted(() => {
      window.removeEventListener("resize", handleResize);
    });

    return {
      shouldShowBanner,
      shouldShowMobileBanner,
      primaryMedia,
      primaryMobileImage,
    };
  },
  template: html`
    <div class="banner_region">
      <div class="main_img-m" v-if="shouldShowMobileBanner && primaryMobileImage">
        <img
          :src="getImageUrl(primaryMobileImage)"
          alt=""
          width="750"
          height="520"
          decoding="async"
        />
      </div>

      <div class="banner" v-if="shouldShowBanner">
        <template v-if="shouldShowBanner && primaryMedia">
          <video
            v-if="primaryMedia.type === 'video'"
            :src="getVideoUrl(primaryMedia.src)"
            preload="metadata"
            autoplay
            muted
            loop
            playsinline
          ></video>
          <img
            v-else-if="primaryMedia.type === 'image'"
            loading="eager"
            fetchpriority="high"
            :src="getImageUrl(primaryMedia.src)"
            alt=""
            width="1920"
            height="378"
          />
        </template>
      </div>
      <div class="banner_title">
        <p class="title_1">{{shopName}}</p>
        <p class="title_2">{{shopEnName}}</p>
      </div>
      <div class="title_3">
        Best Way Travel
        <div class="hr"></div>
      </div>
    </div>
  `,
  methods: {
    getImageUrl: function (image) {
      let baseUrl = "";
      if (window.location.href.includes("localhost")) {
        baseUrl = "https://www.ibwt.com.tw";
      } else if (window.location.href.includes(".bbctour")) {
        baseUrl = "https://www.bwt.com.tw";
      }
      return baseUrl + image;
    },
    getVideoUrl: function (video) {
      let baseUrl = "";
      if (window.location.href.includes("localhost")) {
        baseUrl = "https://www.ibwt.com.tw";
      } else if (window.location.href.includes(".bbctour")) {
        baseUrl = "https://www.bwt.com.tw";
      }
      return baseUrl + video;
    },
  },
});
